import tw from 'twin.macro';

const Skeleton = ({ skeletonStyle }) => (
  <div css={[tw`animate-pulse bg-white/10 w-full h-full`, skeletonStyle]} />
);

export default Skeleton;
